/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useContext } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BrandColors, Text } from '@blend/enterprise-components';

import * as format from 'blb-utils/format';
import { TitleContext } from './';

const styles = StyleSheet.create({
  trackerCard: {
    backgroundColor: 'white',
    border: `1px solid ${BrandColors.CLOUD_30}`,
    borderRadius: 3,
    padding: 20,
  },
  trackerLabel: {
    textAlign: 'left',
    width: '25%',
  },
  trackerLabelWide: {
    textAlign: 'left',
    width: '50%',
  },
  trackerTable: {
    width: '100%',
  },
});

export const InstantTitleTrackerCard: React.FC = () => {
  const { instantTitleActivity } = useContext(TitleContext);
  if (!instantTitleActivity) {
    return null;
  }
  const { createdAt, stage, message } = instantTitleActivity;

  return (
    <div className={css(styles.trackerCard)}>
      <table className={css(styles.trackerTable)}>
        <thead>
          <tr>
            <th className={css(styles.trackerLabel)}>
              <Text weight="semibold">Status</Text>
            </th>
            <th className={css(message ? styles.trackerLabel : styles.trackerLabelWide)}>
              <Text weight="semibold">Timestamp</Text>
            </th>
            {message && (
              <th className={css(styles.trackerLabel)}>
                <Text weight="semibold">Message</Text>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Text>{format.titleCase(stage)}</Text>
            </td>
            <td>
              <Text>{new Date(createdAt).toLocaleString()}</Text>
            </td>
            {message && (
              <td>
                <Text>{message}</Text>
              </td>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};
